var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15443_90969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5962 4.29297C10.2916 4.29297 9.01628 4.67983 7.93155 5.40463C6.84681 6.12943 6.00136 7.15961 5.50211 8.36491C5.00286 9.5702 4.87223 10.8965 5.12675 12.176C5.38126 13.4555 6.00949 14.6309 6.93198 15.5534C7.85448 16.4759 9.0298 17.1041 10.3093 17.3586C11.5889 17.6131 12.9152 17.4825 14.1204 16.9832C15.3257 16.484 16.3559 15.6385 17.0807 14.5538C17.8055 13.4691 18.1924 12.1938 18.1924 10.8892C18.1924 10.0229 18.0218 9.16519 17.6903 8.36491C17.3588 7.56462 16.8729 6.83746 16.2604 6.22495C15.6479 5.61244 14.9207 5.12656 14.1204 4.79507C13.3202 4.46358 12.4624 4.29297 11.5962 4.29297ZM11.5962 16.1661C10.5525 16.1661 9.53227 15.8566 8.66448 15.2768C7.79668 14.6969 7.12033 13.8728 6.72093 12.9086C6.32153 11.9443 6.21702 10.8833 6.42064 9.85968C6.62425 8.83605 7.12683 7.89579 7.86482 7.15779C8.60282 6.4198 9.54308 5.91721 10.5667 5.7136C11.5903 5.50999 12.6514 5.61449 13.6156 6.01389C14.5798 6.41329 15.404 7.08965 15.9838 7.95744C16.5637 8.82523 16.8731 9.84548 16.8731 10.8892C16.8731 12.2887 16.3172 13.6309 15.3276 14.6205C14.3379 15.6101 12.9957 16.1661 11.5962 16.1661Z",
    fill: "url(#paint0_radial_15443_90969)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5971 8.90908C11.9614 8.90908 12.2567 8.61376 12.2567 8.24946C12.2567 7.88517 11.9614 7.58984 11.5971 7.58984C11.2328 7.58984 10.9375 7.88517 10.9375 8.24946C10.9375 8.61376 11.2328 8.90908 11.5971 8.90908Z",
    fill: "url(#paint1_linear_15443_90969)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5971 9.57031C11.4222 9.57031 11.2544 9.63981 11.1307 9.76351C11.007 9.88721 10.9375 10.055 10.9375 10.2299V13.528C10.9375 13.703 11.007 13.8707 11.1307 13.9944C11.2544 14.1182 11.4222 14.1876 11.5971 14.1876C11.7721 14.1876 11.9398 14.1182 12.0635 13.9944C12.1872 13.8707 12.2567 13.703 12.2567 13.528V10.2299C12.2567 10.055 12.1872 9.88721 12.0635 9.76351C11.9398 9.63981 11.7721 9.57031 11.5971 9.57031Z",
    fill: "url(#paint2_linear_15443_90969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15443_90969",
    x: 0.712475,
    y: 0.00544405,
    width: 21.7704,
    height: 21.7665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.14376
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15443_90969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15443_90969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15443_90969",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1924 4.29297) rotate(135) scale(18.6568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB71A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376712,
    stopColor: "#FF9E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674419,
    stopColor: "#F9831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15443_90969",
    x1: 10.5474,
    y1: 7.58984,
    x2: 12.4748,
    y2: 8.4431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD20C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FC6C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FE8549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15443_90969",
    x1: 10.5474,
    y1: 9.57031,
    x2: 12.8162,
    y2: 9.85729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD20C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FC6C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FE8549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.387cdbd9174af9b62598203e2c74f4c0.svg";
export { ForwardRef as ReactComponent };